import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { useMediaQuery } from '@mantine/hooks';
import { image_url, is_mobile_view } from '../config';

const CustomSlider = ({
  children,
  slidesToShow,
  showArrowsOnMobile = false,
  hideArrows = false,
  className,
}) => {
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const settings = {
    arrows: !hideArrows && (showArrowsOnMobile || !isMobileScreen),
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    useCss: true,
    pauseOnHover: true,
  };
  return (
    <div className={className}>
      <Slider {...settings}>{children}</Slider>
    </div>
  );
};

export default CustomSlider;
